import { render } from "./Unauthorized.vue?vue&type=template&id=01952a46"
import script from "./Unauthorized.vue?vue&type=script&lang=ts"
export * from "./Unauthorized.vue?vue&type=script&lang=ts"
script.render = render

export default script